// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"buttonWrapper--vI9D1","button":"button--qSmjD","large":"large--ehTi1","full":"full--GP93n","center":"center--I3OYA","loader":"loader--K_iMY"};